import { render, staticRenderFns } from "./screenOperation.vue?vue&type=template&id=506eefdf&scoped=true&"
import script from "./screenOperation.vue?vue&type=script&lang=js&"
export * from "./screenOperation.vue?vue&type=script&lang=js&"
import style0 from "./screenOperation.vue?vue&type=style&index=0&id=506eefdf&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506eefdf",
  null
  
)

export default component.exports